module.exports = __webpack_public_path__ + "static/media/joyable9_preview.8dbd4a4f.jpg";